import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from "@/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

serviceWorkerRegistration.register({
  onSuccess: () => {
    window.dispatchEvent(new CustomEvent("halalin-pwa", { detail: { kind: "cached" } }));
  },
  onUpdate: (registration) => {
    window.dispatchEvent(
      new CustomEvent("halalin-pwa", { detail: { kind: "update", registration } }),
    );
  },
});
